import { useState as P, useCallback as w, isValidElement as A, cloneElement as G, useMemo as N } from "react";
import { c as R, a as z } from "./index-b2b4ab51.js";
import { c as g, a as u, f as D, o as M, g as B } from "./chunk-KRPLQIP4-1ae0870d.js";
import "@emotion/react";
import { j as n } from "./jsx-runtime-721af1ab.js";
import { S as F } from "./chunk-5PH6ULNP-22f0eb74.js";
import { u as H } from "./chunk-DMO4EI7P-70e4c539.js";
var [Y, L] = R({
  strict: !1,
  name: "ButtonGroupContext"
});
function O(r) {
  const [t, e] = P(!r);
  return { ref: w((a) => {
    a && e(a.tagName === "BUTTON");
  }, []), type: t ? "button" : void 0 };
}
function f(r) {
  const { children: t, className: e, ...s } = r, o = A(t) ? G(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, a = g("chakra-button__icon", e);
  return /* @__PURE__ */ n.jsx(
    u.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...s,
      className: a,
      children: o
    }
  );
}
f.displayName = "ButtonIcon";
function h(r) {
  const {
    label: t,
    placement: e,
    spacing: s = "0.5rem",
    children: o = /* @__PURE__ */ n.jsx(F, { color: "currentColor", width: "1em", height: "1em" }),
    className: a,
    __css: c,
    ...m
  } = r, p = g("chakra-button__spinner", a), l = e === "start" ? "marginEnd" : "marginStart", i = N(
    () => ({
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute",
      [l]: t ? s : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...c
    }),
    [c, t, l, s]
  );
  return /* @__PURE__ */ n.jsx(u.div, { className: p, ...m, __css: i, children: o });
}
h.displayName = "ButtonSpinner";
var U = D((r, t) => {
  const e = L(), s = H("Button", { ...e, ...r }), {
    isDisabled: o = e == null ? void 0 : e.isDisabled,
    isLoading: a,
    isActive: c,
    children: m,
    leftIcon: p,
    rightIcon: l,
    loadingText: i,
    iconSpacing: d = "0.5rem",
    type: x,
    spinner: _,
    spinnerPlacement: b = "start",
    className: v,
    as: y,
    ...k
  } = M(r), I = N(() => {
    const E = { ...s == null ? void 0 : s._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...s,
      ...!!e && { _focus: E }
    };
  }, [s, e]), { ref: C, type: T } = O(y), S = { rightIcon: l, leftIcon: p, iconSpacing: d, children: m };
  return /* @__PURE__ */ n.jsxs(
    u.button,
    {
      ref: z(t, C),
      as: y,
      type: x ?? T,
      "data-active": B(c),
      "data-loading": B(a),
      __css: I,
      className: g("chakra-button", v),
      ...k,
      disabled: o || a,
      children: [
        a && b === "start" && /* @__PURE__ */ n.jsx(
          h,
          {
            className: "chakra-button__spinner--start",
            label: i,
            placement: "start",
            spacing: d,
            children: _
          }
        ),
        a ? i || /* @__PURE__ */ n.jsx(u.span, { opacity: 0, children: /* @__PURE__ */ n.jsx(j, { ...S }) }) : /* @__PURE__ */ n.jsx(j, { ...S }),
        a && b === "end" && /* @__PURE__ */ n.jsx(
          h,
          {
            className: "chakra-button__spinner--end",
            label: i,
            placement: "end",
            spacing: d,
            children: _
          }
        )
      ]
    }
  );
});
U.displayName = "Button";
function j(r) {
  const { leftIcon: t, rightIcon: e, children: s, iconSpacing: o } = r;
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    t && /* @__PURE__ */ n.jsx(f, { marginEnd: o, children: t }),
    s,
    e && /* @__PURE__ */ n.jsx(f, { marginStart: o, children: e })
  ] });
}
export {
  U as B
};
